import CustomerListItem from '@/components/CustomerListItem.vue';
export default {
    props: {
        customers: Array
    },
    components: {
        CustomerListItem
    }
};
